<template>
  <benefit-dialog :type="2" :visible="visible">
    <h2 class="benefit-title" slot="title">您已获得{{amount}}{{benefitType === 'vip' ? '天白金会员' : '元会员代金券'}}</h2>
    <div slot="body" class="benefit-vip-box" :class="benefitType">
      <div  class="benefit-card" :class="benefitType">
        <span v-if="benefitType === 'voucher'" class="amount">{{amount}}元代金券</span>
      </div>
      <ul class="info-list">
        <li class="info-item">· 请在手机迅雷中使用<span class="highlight">{{phoneNumber}}</span>登录激活</li>
        <li class="info-item">· 请在{{ toDate }}前激活</li>
        <li class="info-item" >
          · 如未安装手机迅雷，{{downloadUrl ? '请点击下载' : '请前往应用商城下载'}}
        </li>
      </ul>
    </div>
    <benefit-button slot="footer" @click.native="handleAction" :download-url="downloadUrl">
      <template v-if="downloadUrl">安装手机迅雷</template>
      <template v-else>我知道了</template>
    </benefit-button>
  </benefit-dialog>
</template>

<script>
import BenefitButton from '@/components/benefit/button.vue'
import BenefitDialog from '@/components/benefit/dialog.vue'
import eventHub from './eventHub'
import { stat } from './stat';

export default {
  components: {
    BenefitButton,
    BenefitDialog
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    downloadUrl: {
      type: [String , Number],
      required: true
    },
    from: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      amount: 0,
      benefitType: '',
      validTime: '',
      phoneNumber: '',
      isNewUser: false
    }
  },
  methods: {
    handleAction() {
      if (this.downloadUrl) {
        stat('event', 'page_alert_click', {from: this.from, isnew: this.isNewUser ? 'new' : 'old'})
      } else {
        eventHub.$emit('update:visible', 2, false)
      }
    }
  },
  computed: {
    toDate() {
      const timestamp = new Date(Number(this.validTime))
      const year = timestamp.getFullYear()
      const realMonth = timestamp.getMonth() + 1
      const month = `${realMonth < 10 ? '0' : ''}${realMonth}`
      const day = timestamp.getDate()
      const hour = timestamp.getHours()
      const minute = timestamp.getMinutes()
      return `${year}-${month}-${day} ${hour}:${minute}`
    }
  },
  created() {
    eventHub.$on(
      'update:props',
      (type, { benefitType, amount, validTime, phoneNumber, isNewUser }) => {
        this.benefitType = benefitType
        this.amount = amount
        this.validTime = validTime
        this.phoneNumber = phoneNumber
        this.isNewUser = isNewUser
        this.$nextTick(() => {
          stat('event', 'page_alert_show', {from: this.from, isnew: this.isNewUser ? 'new' : 'old'})
        })
      }
    )
  },
  beforeDestroy() {
    eventHub.$off('update:props')
  }
}
</script>

<style lang="scss">
.benefit-vip-box {
  margin: 0 20px 0 20px; /*no*/
  display: flex;
  flex-direction: column;
  .benefit-card {
    position: relative;
    background-size: contain;
    .amount {
      position: absolute;
      bottom: 8.333px; /*no*/
      left: 50%;
      transform: translateX(-50%);
      font-size: 14px; /*no*/
      color: #ba7f2b;
      text-align: center;
    }
    &.vip {
      width: 156px; /*no*/
      height: 80px; /*no*/
      margin: 20px auto 28px auto; /*no*/
      background-image: url('~assets/benefit/vip-s@3x.png');
    }
    &.voucher {
      width: 216px; /*no*/
      height: 75px; /*no*/
      margin: 24px auto 29px auto; /*no*/
      background-image: url('~assets/benefit/voucher-s@3x.png');
    }
  }
  .info-list {
    list-style: none;
    padding: 0;
    margin-bottom: 29px; /*no*/
    .info-item {
      position: relative;
      font-size: 14px; /*no*/
      color: #26292d;
      line-height: 20px; /*no*/
      margin-bottom: 8px; /*no*/
      .highlight {
        color: #0755ff;
      }
      &:last-child {
        margin-bottom: 0;
      }
      // &::before {
      //   content: '';
      //   position: absolute;
      //   width: 2px; /*no*/
      //   height: 2px; /*no*/
      //   border-radius: 100%;
      //   background: #000;
      //   top: 50%;
      //   left: -10px;
      //   transform: translate(-50%, -50%);
      // }
    }
  }
}
</style>
